import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getAllVehicles = createAsyncThunk(
    'vehicle/getAllVehicles',
    async ({ skip, limit, search, status, vehicle_status }, { rejectWithValue }) => {
        try {
            const params = {};
            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;
            if (status) params.status = status;
            if (vehicle_status) params.vehicle_status = vehicle_status;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/vehicle`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const addNewVehicle = createAsyncThunk(
    'vehicle/addNewVehicle',
    async (vehicleData, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };

            const formData = new FormData();

            formData.append("name", vehicleData.name);
            formData.append("description", vehicleData.description);
            formData.append("lot_nm", vehicleData.lot_nm);
            formData.append("auction_house", vehicleData.auction_house);
            formData.append("price", vehicleData.price);
            formData.append("discount_price", vehicleData.discountPrice);
            formData.append("chassis_no", vehicleData.chassisNo);
            formData.append("mileage", vehicleData.mileage);
            formData.append("engine_capacity", vehicleData.engineCapacity);
            formData.append("reg_year", vehicleData.regYear);
            formData.append("mfg_year", vehicleData.mfgYear);
            formData.append("stock_no", vehicleData.stockNo);
            formData.append("steering", vehicleData.steering);
            formData.append("wheel_drive", vehicleData.wheel_drive);
            formData.append("exterior_condition", vehicleData.exterior_condition);
            formData.append("interior_condition", vehicleData.interior_condition);
            formData.append("no_of_doors", vehicleData.doorsNo);
            formData.append("no_of_seats", vehicleData.seatsNo);
            formData.append("makeId", vehicleData.makeId);
            formData.append("modelId", vehicleData.modelId);
            formData.append("modelCodeId", vehicleData.modelCodeId);
            formData.append("vehicleTypeId", vehicleData.vehicleTypeId);
            formData.append("interiorColorId", vehicleData.interiorColorId);
            formData.append("exteriorColorId", vehicleData.exteriorColorId);
            formData.append("countryId", vehicleData.countryId);
            formData.append("fuelId", vehicleData.fuelId);
            formData.append("transmissionId", vehicleData.transmissionId);
            formData.append("thumbnail", vehicleData.thumbnail);
            formData.append("commonly_called", vehicleData.commonly_called);
            formData.append("engine_no", vehicleData.engine_no);
            formData.append("body_color", vehicleData.body_color);
            formData.append("grade", vehicleData.grade);
            formData.append("selling_price", vehicleData.selling_price);
            formData.append("lease_or_loan_amount", vehicleData.lease_or_loan_amount);
            formData.append("registration_status", vehicleData.registration_status);
            formData.append("isFeatured", vehicleData.isFeatured);
            formData.append("isPopular", vehicleData.isPopular);
            const images = vehicleData.images.map((image) =>
                new File([image.file], `${image.order}`, {
                    type: image.file.type,
                    lastModified: image.file.lastModified
                })
            );
            images.forEach((file) => {
                formData.append("images", file);
            });

            const features = vehicleData.vehicle_features.map(feature => feature.id).join(",");
            formData.append("features", features);
            // formData.append("name", "Test Vehicle 123456");
            // formData.append("description", "vehicleData description");
            // formData.append("price", "12000");
            // formData.append("discount_price", "100");
            // formData.append("chassis_no", "12scgwh");
            // formData.append("mileage", "3600");
            // formData.append("engine_capacity", "1500");
            // formData.append("reg_year", "2010");
            // formData.append("mfg_year", "2008");
            // formData.append("stock_no", "12Sc");
            // formData.append("steering", "RHD");
            // formData.append("wheel_drive", "WD2");
            // formData.append("exterior_condition", "R");
            // formData.append("interior_condition", "A");
            // formData.append("no_of_doors", "4");
            // formData.append("no_of_seats", "5");
            // formData.append("makeId", '4');
            // formData.append("modelId", "3");
            // formData.append("modelCodeId", "7");
            // formData.append("vehicleTypeId", "7");
            // formData.append("interiorColorId", "2");
            // formData.append("exteriorColorId", "2");
            // formData.append("countryId", "8");
            // formData.append("fuelId", "9");
            // formData.append("transmissionId", "11");
            // formData.append("features", "2");
            // formData.append("thumbnail", vehicleData.thumbnail);
            // const images = vehicleData.images.map((image) => 
            //     new File([image.file], `${image.order}`, { 
            //         type: image.file.type, 
            //         lastModified: image.file.lastModified 
            //     })
            // );

            // // Now, append images to formData
            // images.forEach((file) => {
            //     formData.append("images", file);
            // });            
            const response = await axios.post(`${PUBLIC_BASE_URL}/vehicle/create-vehicle`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editVehicle = createAsyncThunk(
    'vehicle/editVehicle',
    async ({ vehicleData, thumbnail, newImages, existingImages, removedImages, allVehicleFeatures }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };
            const formData = new FormData();

            const appendIfAvailable = (key, value) => {
                if (value !== null && value !== undefined && value !== "") {
                    formData.append(key, value);
                }
            };

            appendIfAvailable("id", vehicleData.id);
            appendIfAvailable("name", vehicleData.name);
            appendIfAvailable("lot_nm", vehicleData.lot_nm);
            appendIfAvailable("auction_house", vehicleData.auction_house);
            appendIfAvailable("description", vehicleData.description);
            appendIfAvailable("price", vehicleData.price);
            appendIfAvailable("discount_price", vehicleData.discountPrice);
            appendIfAvailable("chassis_no", vehicleData.chassis_no);
            appendIfAvailable("mileage", vehicleData.mileage);
            appendIfAvailable("engine_capacity", vehicleData.engine_capacity);
            appendIfAvailable("reg_year", vehicleData.reg_year);
            appendIfAvailable("mfg_year", vehicleData.mfg_year);
            appendIfAvailable("steering", vehicleData.steering);
            appendIfAvailable("wheel_drive", vehicleData.wheel_drive);
            appendIfAvailable("exterior_condition", vehicleData.exterior_condition);
            appendIfAvailable("interior_condition", vehicleData.interior_condition);
            appendIfAvailable("no_of_doors", vehicleData.no_of_doors);
            appendIfAvailable("no_of_seats", vehicleData.no_of_seats);
            appendIfAvailable("makeId", vehicleData.makeId);
            appendIfAvailable("modelId", vehicleData.modelId);
            appendIfAvailable("modelCodeId", vehicleData.modelCodeId);
            appendIfAvailable("vehicleTypeId", vehicleData.vehicleTypeId);
            appendIfAvailable("interiorColorId", vehicleData.interiorColorId);
            appendIfAvailable("exteriorColorId", vehicleData.exteriorColorId);
            appendIfAvailable("countryId", vehicleData.countryId);
            appendIfAvailable("fuelId", vehicleData.fuelId);
            appendIfAvailable("transmissionId", vehicleData.transmissionId);
            appendIfAvailable("isFeatured", vehicleData.isFeatured);
            appendIfAvailable("isPopular", vehicleData.isPopular);
            appendIfAvailable("status", vehicleData.status);
            appendIfAvailable("commonly_called", vehicleData.commonly_called);
            appendIfAvailable("engine_no", vehicleData.engine_no);
            appendIfAvailable("body_color", vehicleData.body_color);
            appendIfAvailable("grade", vehicleData.grade);
            appendIfAvailable("selling_price", vehicleData.selling_price);
            appendIfAvailable("lease_or_loan_amount", vehicleData.lease_or_loan_amount);
            appendIfAvailable("registration_status", vehicleData.registration_status);
            const features = allVehicleFeatures?.map(feature => feature.id).join(",");
            appendIfAvailable("features", features);
            appendIfAvailable("thumbnail", thumbnail);

            const images = newImages.map((image) =>
                new File([image.file], `${image.order_no}`, {
                    type: image.file.type,
                    lastModified: image.file.lastModified
                })
            );
            images.forEach((file) => {
                formData.append("images", file);
            });

            const removed_images = [...new Set(removedImages?.map(image => image.id))].join(",");
            appendIfAvailable("removed_images", removed_images);

            existingImages.forEach((image, index) => {
                formData.append(`existing_images[${index}][id]`, image.id);
                formData.append(`existing_images[${index}][order_no]`, image.order_no);
            });
            const response = await axios.put(`${PUBLIC_BASE_URL}/vehicle/update-vehicle-info`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);

export const editVehicleImage = createAsyncThunk(
    'vehicle/editVehicleImage',
    async (data, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',

                },
                withCredentials: true,
            };

            const formData = new FormData();
            if (data.file) formData.append('image', data.file);
            if (data.id) formData.append('vehicleId', data.id);

            const response = await axios.put(
                `${PUBLIC_BASE_URL}/vehicle/update-image`,
                formData,
                config
            );
            return response.data;
        } catch (err) {
            if (err.message === 'Network Error') {
                return rejectWithValue({
                    message: 'Network Error',
                    status: 404,
                    statusText: err.code,
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred');
            }
        }
    }
);

export const getVehicleById = createAsyncThunk(
    'vehicle/getVehicleById',
    async ({ id }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/vehicle/${id}`, config);
            return (response.data);

        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    response: {
                        data: {
                            message: "Network Error",
                            status: err.code,
                            statusText: err.code,
                        },
                    },
                });
            } else {
                return rejectWithValue(
                    err.response?.data?.message || 'An error occurred'
                );
            }
        }
    }
);

export const editVehicleStatus = createAsyncThunk(
    'vehicle/editVehicleStatus',
    async ({ vehicleData }, { rejectWithValue }) => {
        try {
            const config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                withCredentials: true,
            };
            const formData = new FormData();

            const appendIfAvailable = (key, value) => {
                if (value !== null && value !== undefined && value !== "") {
                    formData.append(key, value);
                }
            };

            appendIfAvailable("id", vehicleData.id);
            appendIfAvailable("status", vehicleData.status);
            const response = await axios.put(`${PUBLIC_BASE_URL}/vehicle/update-vehicle-info`, formData, config);
            return response.data;
        } catch (err) {
            if (err.message === "Network Error") {
                return rejectWithValue({
                    message: "Network Error",
                    status: err.code,
                    success: false
                });
            } else {
                return rejectWithValue(err.response?.data || 'Unknown error occurred.');
            }
        }
    }
);
